import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { openIntervalTargets } from '../utils/intervalTargetsSso';

/**
 * Opens Interval Targets through the SSO handshake, tracking only whether this
 * caller's own request is in flight.
 *
 * Local state rather than a redux slice, matching useDataAccessConsole: there
 * is nothing to share, and each entry point wants its own spinner.
 */
export default function useIntervalTargets() {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const open = useCallback(async () => {
    // Guards against a double click opening two tabs.
    if (loading) return;
    setLoading(true);
    try {
      await openIntervalTargets((message) => enqueueSnackbar(message, { variant: 'error' }));
    } finally {
      setLoading(false);
    }
  }, [loading, enqueueSnackbar]);

  return { loading, open };
}
